import { BadgeColor } from "design-angular-kit";

export function getBadgeType(status: string): BadgeColor {
  switch (status) {
    case 'NEW':
    case 'Presa in Carico':
      return 'primary';
    case 'Completata':
      return 'success';
    case 'Annullata':
      return 'danger';
    case 'Conferma struttura':
      return 'warning';
    default:
      return 'secondary';
  }
}